import { render, staticRenderFns } from "./SubscriptionBlock.vue?vue&type=template&id=e0886edc&scoped=true&"
import script from "./SubscriptionBlock.vue?vue&type=script&lang=js&"
export * from "./SubscriptionBlock.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionBlock.vue?vue&type=style&index=0&id=e0886edc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0886edc",
  null
  
)

export default component.exports